import { render, staticRenderFns } from "./BatchModifyShortTitle.vue?vue&type=template&id=d84a6022&scoped=true"
import script from "./BatchModifyShortTitle.vue?vue&type=script&lang=js"
export * from "./BatchModifyShortTitle.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyShortTitle.vue?vue&type=style&index=0&id=d84a6022&prod&scoped=true&lang=css"
import style1 from "./batch-modify.css?vue&type=style&index=1&id=d84a6022&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_cache-loader@4.1.0_webpack@4.47.0_supports-_28b733ef3ef89602fda58894ac543489/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84a6022",
  null
  
)

export default component.exports